module.exports = __webpack_public_path__ + "img/speed-3.d631aee2.png";